<template>
  <!-- 招新报表 -->
  <div>
    <SpCardContent>
      <!-- 总的数据展示 -->
      <div class="top-left">
        <div class="left-item">
          <div>本月进群总人数</div>
          <div>
            <span class="count">{{ total_recruit_number }}</span>
          </div>
        </div>
      </div>
      <div class="top-tips">
        <!-- 列表的搜索和操作 -->
        <div class="top-search">
          <el-date-picker
            v-model="params.date"
            class="year"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
            :picker-options="pickerOptions"
          />
          <el-input
            v-if="activeName === 'guide'"
            v-model="params.employee_number"
            placeholder="导购工号"
            class="input-m m-r-6"
            clearable
          />
          <el-input
            v-model="params.key_word"
            :placeholder="activeName === 'guide' ? '导购姓名/手机号' : '群管理员昵称/群ID'"
            class="input-m m-r-6"
            clearable
          />

          <el-button
            v-if="activeName === 'guide'"
            size="small"
            @click="storeVisible = true"
          >
            <span v-if="selectStoreData.length > 0">已选择 {{ selectStoreData.length }}家门店</span>
            <span v-else>添加门店以筛选</span>
          </el-button>
          <el-button
            v-else
            size="small"
            @click="communityVisible = true"
          >
            <span
              v-if="selectCommunityData.length > 0"
            >已选择 {{ selectCommunityData.length }}个社群</span>
            <span v-else>添加社群以筛选</span>
          </el-button>

          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getList()"
          >
            搜索
          </el-button>
        </div>
      </div>
      <el-button
        type="primary"
        class="exportbtn"
        @click="exportDialogVisible = true"
      >
        导出{{ activeNameText }}业绩
      </el-button>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="导购维度"
          name="guide"
        />
        <!-- <el-tab-pane label="社群维度" name="community"></el-tab-pane> -->

        <!-- 列表展示 -->
        <el-table
          v-loading="loading"
          :data="list"
        >
          <template v-if="activeName === 'guide'">
            <el-table-column
              prop="employee_number"
              label="导购工号"
            />
            <el-table-column
              prop="salesperson_name"
              label="导购姓名"
            />
            <el-table-column
              prop="prop"
              label="所在门店"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.store && scope.row.store.store_name">{{
                  scope.row.store.store_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="prop"
              label="导购类型"
            >
              <template slot-scope="scope">
                {{ scope.row.employee_status === 1 ? '员工' : '编外' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="chat_number"
              label="关联社群数"
            />
            <el-table-column
              prop="sum_recruit_number"
              label="本月招新入群客户数"
            />
          </template>
          <template v-if="activeName === 'community'">
            <el-table-column
              prop="prop"
              label="群ID"
            />
            <el-table-column
              prop="prop"
              label="群管理员"
            />
            <el-table-column
              prop="prop"
              label="绑定门店"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.salesperson">{{
                  scope.row.salesperson.salesperson_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="prop"
              label="当月月初群人数"
            />
            <el-table-column
              prop="prop"
              label="截止当月底群人数"
            />
            <el-table-column
              prop="prop"
              label="当月新入群客户数"
            />
          </template>

          <!-- 列表操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleListClick(scope.row)"
              >
                明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <el-pagination
          class="content-padded content-center"
          background
          :current-page="params.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-tabs>

      <!-- 明细对话框 -->
      <el-dialog
        :title="showDate + '月社群招新明细'"
        :visible.sync="dialogVisible"
        width="820px"
      >
        <div>
          <el-table :data="detailList">
            <template v-if="activeName === 'guide'">
              <el-table-column
                prop="chat_id"
                label="群ID"
              />
              <el-table-column
                prop="prop"
                label="群名称"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.customer_base">{{ scope.row.customer_base.name }}</span>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column
                prop="prop"
                label="员工编号"
              />
              <el-table-column
                prop="prop"
                label="员工姓名"
              />
            </template>

            <el-table-column
              prop="sum_recruit_number"
              label="本月招新人数"
            />
          </el-table>
        </div>
      </el-dialog>

      <!-- 导出报表对话框 -->
      <SpExportList
        v-model="exportDialogVisible"
        show-store-select
        show-employee-status
        :files-type="4"
      />

      <!-- 编辑门店对话框 -->
      <SpStoreSelect
        v-model="storeVisible"
        :select-data="selectStoreData"
        @chooseStore="chooseStore"
      />

      <!-- 选择社群 -->
      <SpCommunitySelect
        v-model="communityVisible"
        :select-data="selectCommunityData"
        @chooseCommunity="chooseCommunity"
      />
    </SpCardContent>
  </div>
</template>

<script>
export default {
  name: 'Recruitlist',
  data () {
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },
      loading: false, //列表的加载
      activeName: 'guide', //当前tab选中
      activeNameText: '导购', //选中的tab的名称
      list: [], //列表数据
      total: {
        pay_fee: 0, //本月总业绩
        pay_num: 0 //本月总订单数
      },
      total_recruit_number: 0, //本月进群总人数
      total_count: 0, //总数据量
      params: {
        page: 1,
        page_size: 20,
        date:
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1 < 10
            ? '0' + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1),
        employee_number: '', //导购的员工工号
        key_word: '', //导购员名字或手机号
        store_ids: '',
        chat_ids: ''
      },

      dialogVisible: false, //明细对话框显示与否
      detailList: [], //明细列表数据

      exportDialogVisible: false, //导出对话框展示与否
      storeVisible: false, //选择门店展示
      selectStoreData: [], //选择门店数据
      communityVisible: false, //选择社群展示
      selectCommunityData: [] //选择社群数据
    }
  },
  computed: {
    showDate () {
      let showDate = this.params.date.split('-')[1]
      showDate = +showDate <= 9 ? +showDate : +showDate
      return showDate
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取业绩列表数据
    async getList () {
      this.loading = true
      if (this.activeName === 'guide') {
        // 获取导购列表数据
        const data = await this.$api.performance.getRecruitList(this.params).catch(() => {
          this.loading = false
        })
        if (data) {
          this.list = data.list
          this.total_recruit_number = data.total_recruit_number
          this.total_count = data.total_count
          this.loading = false
        }
      } else {
        // 获取社群业绩列表数据
        const data = {}
        if (data) {
          this.list = data.list
          this.total = {
            pay_fee: data.total_performance, //本月总业绩
            pay_num: data.total_order_num //本月总订单数
          }
          this.total_count = data.total_count
          this.loading = false
        }
      }
    },

    // 点击切换tab
    handleClick (tab, event) {
      this.activeName = tab.name
      if (tab.name === 'guide') {
        this.activeNameText = '导购'
        this.params.chat_ids = ''
      } else {
        this.activeNameText = '社群'
        this.params.store_ids = ''
      }
      this.params.page = 1
      this.getList()
    },

    // 操作-明细
    async handleListClick (row) {
      this.detailList = []
      this.dialogVisible = true
      let params = {
        store_id: row.store_id,
        salesperson_id: row.salesperson_id,
        date: this.params.date
      }
      const data = await this.$api.performance.getRecruitInfo(params)
      if (data) {
        this.detailList = data.list
      }
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 选择店铺数据
    chooseStore (selectdata, storeids) {
      if (selectdata.length > 0) {
        this.selectStoreData = selectdata
        this.params.store_ids = storeids
      } else {
        this.selectStoreData = []
        this.params.store_ids = 0
      }
      this.storeVisible = false
    },

    // 选择社群数据
    chooseCommunity (selectdata, ids) {
      if (selectdata.length > 0) {
        this.selectCommunityData = selectdata
        this.params.chat_ids = ids
      } else {
        this.selectCommunityData = []
        this.params.chat_ids = 0
      }
      this.communityVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.top-tips {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-left {
    display: flex;
    .left-item {
      margin-right: 30px;
    }
  }
  .top-search {
    display: flex;
    .year {
      min-width: 200px;
    }
    > div {
      margin-right: 6px;
    }
  }
}
.count {
  font-size: 26px;
  padding-right: 5px;
}

.exportbtn {
  margin-bottom: 16px;
}
.guide-name {
  padding-left: 38px;
  .guide-pic {
    position: absolute;
    left: 0;
    top: 9px;
  }
  .guide-icon {
    position: absolute;
    left: 0;
    top: 17px;
    margin: auto;
    .iconfont {
      font-size: 34px;
      color: #ccc;
      margin-right: 6px;
    }
  }
}
</style>
